import React, { useState } from 'react';
import MarketingLayout from './Layouts/MarketingLayout';
import { Link } from '@inertiajs/react';

export default function Faq({ faqs }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <MarketingLayout title="Frequently Asked Questions">
      {/* Hero Header */}
      <section className="spx-hero" style={{ paddingBottom: '32px' }}>
        <div className="spx-container animate-fade-in">
          <span className="spx-badge spx-badge-blue" style={{ marginBottom: '16px' }}>Help Center</span>
          <h1 className="spx-title-large">Frequently Asked Questions</h1>
          <p className="spx-body-lead" style={{ maxWidth: '640px', margin: '0 auto' }}>
            Got questions about onboarding, pricing bands, data security, or features? Find quick answers below.
          </p>
        </div>
      </section>

      {/* Accordion List */}
      <section className="spx-section" style={{ backgroundColor: 'var(--bg-secondary)', borderTop: '1px solid var(--border-primary)' }}>
        <div className="spx-container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.8fr', gap: '48px', alignItems: 'start' }}>
            {/* Sidebar info */}
            <div>
              <h2 className="spx-title-small" style={{ marginBottom: '16px' }}>Still have questions?</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '15px', marginBottom: '24px', lineHeight: '1.6' }}>
                Can't find the answer you're looking for? Please contact our sales and support team for direct guidance.
              </p>
              <Link href="/contact" className="spx-btn spx-btn-primary">
                Contact Support <i className="fas fa-arrow-right"></i>
              </Link>
            </div>

            {/* Accordions */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {faqs && faqs.map((faq, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <div 
                    key={faq.id || idx} 
                    className="spx-glass-card" 
                    style={{ 
                      padding: '20px 24px', 
                      cursor: 'pointer',
                      borderColor: isOpen ? 'var(--accent-blue)' : 'var(--glass-border)',
                      background: isOpen ? 'var(--accent-blue-light)' : 'var(--glass-bg)',
                      transition: 'var(--transition-smooth)'
                    }}
                    onClick={() => toggleAccordion(idx)}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                      <h3 className="spx-title-small" style={{ fontSize: '16px', fontWeight: '700', margin: 0, color: 'var(--text-primary)' }}>
                        {faq.question}
                      </h3>
                      <div style={{ 
                        color: isOpen ? 'var(--accent-blue)' : 'var(--text-tertiary)',
                        transform: isOpen ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.2s ease',
                        fontSize: '14px'
                      }}>
                        <i className="fas fa-chevron-down"></i>
                      </div>
                    </div>
                    
                    {isOpen && (
                      <div 
                        style={{ 
                          marginTop: '16px', 
                          paddingTop: '16px', 
                          borderTop: '1px solid var(--border-primary)',
                          color: 'var(--text-secondary)',
                          fontSize: '14px',
                          lineHeight: '1.6'
                        }}
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
